var _this = this;
import * as tslib_1 from "tslib";
import { openPremiumDashboard } from 'owa-whats-new';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { orchestrator } from 'satcheljs';
var upgradeUrl = 'https://premium.outlook.com';
export default orchestrator(openPremiumDashboard, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        if (isControlFeatureEnabled('auth-PremiumDashboardApril')) {
            lazyMountAndShowFullOptions.importAndExecute('premium', 'features');
        }
        else if (isControlFeatureEnabled('auth-PremiumDashboard')) {
            lazyMountAndShowFullOptions.importAndExecute('general', 'Premium');
        }
        else {
            window.open(upgradeUrl, '_blank');
        }
        return [2 /*return*/];
    });
}); });
//# sourceMappingURL=openPremiumDashboard.js.map